import { axiosInstance } from '../../../../../network/apis';
import { TransactionModel } from '../../../auth/models/TransactionModel';

export function getAllTransactions({ params }: { params?: any }) {
  return axiosInstance.get<Array<TransactionModel>>(`/admin/payments`, {
    params,
  });
}
